import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IMediaContainerChildMeasures } from './types'
import { ViewerManagerStructureAPISymbol } from '@wix/thunderbolt-symbols'
import { ViewerAPI } from 'thunderbolt-viewer-manager-types'
import { Component } from '@wix/thunderbolt-becky-root'

const MEDIA_CONTAINER_TYPE = 'wysiwyg.viewer.components.MediaContainer'

const getParent = (compId: string, structureViewerApi: ViewerAPI['structure']) => {
	const parentId = structureViewerApi.getStructure(compId)?.parent
	if (!parentId) {
		return {} as Component
	}

	return structureViewerApi.getStructure(parentId)
}

const mediaContainerChildMeasuresFactory = (
	structureViewerApi: ViewerAPI['structure']
): IMediaContainerChildMeasures => {
	const shouldUseCustomMeasureForMediaContainerChild: IMediaContainerChildMeasures['shouldUseCustomMeasureForMediaContainerChild'] = (
		compId
	) => {
		const parent = getParent(compId, structureViewerApi)
		return !!parent.componentType && parent.componentType === MEDIA_CONTAINER_TYPE
	}

	const getMeasuresForMediaContainerChild: IMediaContainerChildMeasures['getMeasuresForMediaContainerChild'] = (
		compId,
		measureType,
		measuresApi,
		measureMap,
		customMeasure
	) => {
		// mediaContainer child needs to apply custom measures for their parent also
		const element = measuresApi.getCompElement(compId)!
		if (measureType === 'left') {
			return measuresApi.getCompLeft(element, compId, measureMap, true)
		}
		if (measureType === 'top') {
			return measuresApi.getCompTop(element, compId, measureMap, true)
		}

		return customMeasure
	}

	return {
		shouldUseCustomMeasureForMediaContainerChild,
		getMeasuresForMediaContainerChild,
	}
}

export const MediaContainerChildMeasures = withDependencies(
	[ViewerManagerStructureAPISymbol],
	mediaContainerChildMeasuresFactory
)
